import { FC, ReactNode, useRef, useState } from 'react';
import { Card, Flex, NakedButton, Icon } from 'roo-ui/components';
import CollapsibleContent from './primitives';
import { BREAK_POINTS_PX } from 'styles/theme';

const isSmallScreen = () => {
  return window.innerWidth <= BREAK_POINTS_PX[0];
};

interface CollapsibleCardProps {
  children: ReactNode;
  onToggle: (isOpen: boolean) => void;
  collapsedHeight?: number;
  collapsible?: boolean;
  scrollUpOnCollapse?: boolean;
}

const CollapsibleCard: FC<CollapsibleCardProps> = ({
  children,
  onToggle,
  collapsedHeight = 80,
  collapsible = true,
  scrollUpOnCollapse = true,
}) => {
  const [isOpen, toggle] = useState(false);
  const cardRef = useRef<HTMLElement>();

  const toggleCollapsed = () => {
    toggle(!isOpen);
    onToggle.call(null, !isOpen);

    if (cardRef.current && !isOpen === false && scrollUpOnCollapse && isSmallScreen()) {
      cardRef.current.scrollIntoView();
    }
  };

  const ariaLabel = isOpen ? 'Collapse content' : 'Expand content';
  const iconName = isOpen ? 'expandLess' : 'expandMore';

  return (
    <Card p={6} pb={4} mb={5} display="flex" flexDirection="column" ref={cardRef}>
      <CollapsibleContent {...((isOpen || !collapsible) && { className: 'open' })} collapsedHeight={collapsedHeight}>
        {children}
      </CollapsibleContent>
      {collapsible && (
        <NakedButton onClick={toggleCollapsed} color="brand.primary" aria-label={ariaLabel} py="2">
          <Flex>
            {isOpen ? 'View less' : 'View more'}
            <Icon name={iconName} />
          </Flex>
        </NakedButton>
      )}
    </Card>
  );
};

export default CollapsibleCard;
